import { useState, useEffect } from "react";

export const fxStreetNews = (currencyPair) => {
  const [newsData, setNewsData] = useState(null); // News and sentiment data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Fetch news and sentiment data
  useEffect(() => {
    if (!currencyPair) {
      setError("Currency pair is required");
      setLoading(false);
      return;
    }

    const fetchNewsAndSentiment = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch("https://vidplay-api.deng-software.com/fx/articles", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ currencyPair }),
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        setNewsData(data.articles); // Save the news and sentiment data
      } catch (err) {
        setError(`Failed to fetch news and sentiment data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsAndSentiment();
  }, [currencyPair]);

  return { newsData, loading, error };
};
